import "../styles/SponsorCarousel.css";

const SponsorCarousel = ({ sponsors = [] }) => {
  const duplicatedSponsors = [...sponsors, ...sponsors];

  return (
    <div className="sponsor-track-wrapper">
      <div className="sponsor-track">
        {duplicatedSponsors.map((sponsor, index) => (
          <img
            key={`${sponsor.imagen}-${index}`}
            src={sponsor.imagen}
            alt={sponsor.titulo}
            title={sponsor.titulo}
            className="sponsor-logo"
            loading="lazy"
          />
        ))}
      </div>
    </div>
  );
};

export default SponsorCarousel;
